import { FC, ReactNode, useState } from "react";
import { Card, Flex, Modal } from "@payping/web-components";

interface Props {
  title: ReactNode;
  icon: ReactNode;
  modalIcon: ReactNode;
  modalDescription: ReactNode;
  [name: `data-${string}`]: string | undefined;
}
export const CapabilityLayout: FC<Props> = ({ title, icon, modalIcon, modalDescription, ...dataAttributes }) => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <>
      <Card.Ant className="tw-cursor-pointer" cover={icon} onClick={() => setOpenModal(true)} {...dataAttributes}>
        {title}
      </Card.Ant>

      <Modal
        open={openModal}
        title={title}
        closable
        onCancel={() => setOpenModal(false)}
        maskClosable={false}
        footer={null}
      >
        <Flex vertical gap={16}>
          {modalIcon}
          {modalDescription}
        </Flex>
      </Modal>
    </>
  );
};
